<template>
    <div>
        <div v-if="typeInput">
            <rir-input
                    v-model="kpi.value"
                    :readonly="!editing"
                    :label="kpi.name + ' ' + kpi.units"
            />
        </div>
        <div v-if="typeDate">
            <rir-date-picker
                    v-model="kpi.value"
                    :readonly="!editing"
                    :label="kpi.name"
                    :isTime="true"
            />
        </div>
        <div v-if="typeBool">
            <rir-checkbox
                    v-model="kpi.value"
                    :disabled="!editing"
                    :label="kpi.name"
            />
        </div>
    </div>
</template>

<script>
    import Kpi from "../models/Kpi";

    export default {
        name: 'KpiEditField',
        props: {
            kpi: {
                type: Object,
                default: () => new Kpi()
            },
            editing: {
                type: Boolean,
                default: () => false
            }
        },
        data () {
            return {
                listOfStyles: [
                    {id: 'none', value: 'нет'},
                    {id: 'is-normal', value: 'в норме'},
                    {id: 'is-invalid', value: 'превышен'},
                ],
            }
        },
        computed: {
            canBeParent() {
                return this.kpi.maxChildrenCount > 0;
            },
            typeInput() {
                return ['string', 'int', 'double'].indexOf(this.kpi.dataType) != -1;
            },
            typeMinMax() {
                return ['int', 'double'].indexOf(this.kpi.dataType) != -1;
            },
            typeDate() {
                return this.kpi.dataType == 'date';
            },
            typeBool() {
                return this.kpi.dataType == 'bool';
            },
            canSave() {
                return this.kpi.name.length > 0;
            },
            canAddChild() {
                return this.kpi.maxChildrenCount > this.child;
            }
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>
